import useCurrentUser from '~/client/hooks/user/useCurrentUser';
import useSite from '~/client/hooks/useSite';
import type { CashierCurrency, CashierSite } from '~/schema/public';
import useLastTransactionData from './useLastTransactionData';
import { useListGatewaysQuery } from '../graphql/ListGateway.generated';

type Props = {
  currencyConfig: CashierConfig;
};
const useListGateway = ({ currencyConfig }: Props) => {
  const { countryInfo } = useCurrentUser();
  const { site } = useSite();
  const { provider, providerMethod, amount } =
    useLastTransactionData(currencyConfig);

  const listGateway = useListGatewaysQuery({
    skip: !countryInfo?.countryCode || !provider,
    variables: {
      input: {
        currency: currencyConfig.name as CashierCurrency,
        site: site as CashierSite,
        country: countryInfo?.countryCode as string,
        operation: 'deposit',
      },
    },
  });

  const data = listGateway.data?.cashier?.gatewaysConfig?.edges?.filter(
    (prov) =>
      prov.node?.provider === provider && prov.node?.method === providerMethod,
  );

  return {
    urlAlias: data?.[0]?.node?.urlAlias,
    amount,
  };
};

export default useListGateway;
